import { render, staticRenderFns } from "./BrigadeForkliftTruckFieldTable.vue?vue&type=template&id=d05017b6&"
import script from "./BrigadeForkliftTruckFieldTable.vue?vue&type=script&lang=js&"
export * from "./BrigadeForkliftTruckFieldTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTr,QTh,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QTr,QTh,QTd,QBtn,QTooltip}, component.options.components || {})
